// eslint-disable-next-line jira/restricted/cookie -- This reduced TS complexity by 3,114,190 across Jira
import Cookies from 'js-cookie';

/*
This logic was ported from MobileUtils class from jira monolith to
provide the same conditions for checking whether the user agent is mobile or not.
*/

const DESKTOP_SWITCH_COOKIE_KEY = 'jira.mobile.desktop.switch';
const MOBILE_USER_AGENT = new RegExp('(iPhone;|iPhone Simulator;|iPad;|iPod;|iPod touch|Android)');
const MOBILE_STRING_IN_USER_AGENT = new RegExp('Mobile');
const IPAD_USER_AGENT = new RegExp('iPad;');
const IOS_USER_AGENT = new RegExp('(iPhone;|iPad;|iPod;)');
const ANDROID_USER_AGENT = new RegExp('Android');

// This regex matches the following iOS rendering engines:
// 1. Chrome for iOS
// 2. Firefox for iOS
// 3. Edge for iOS
const NON_SAFARI_IOS_RENDERING_ENGINE_USER_AGENT = new RegExp('CriOS|FxiOS|EdgiOS');

/**
 * Determines if the current user agent is supported based on specific criteria.
 * It checks if the execution is server-side, the presence and validity of the navigator
 * object, and matches against known patterns for Android Chrome and mobile user agents,
 * excluding old Android versions.
 */
export const isSupportedUserAgent = (): boolean => {
	if (__SERVER__) return false;

	if (!globalThis.navigator?.userAgent.length) {
		return false;
	}

	const isMobile = MOBILE_USER_AGENT.test(globalThis.navigator?.userAgent);

	return isMobile;
};
export const isAndroidUserAgent = (): boolean => {
	return ANDROID_USER_AGENT.test(globalThis.navigator?.userAgent);
};

export const isIosUserAgent = (): boolean => IOS_USER_AGENT.test(globalThis.navigator?.userAgent);
/**
 * Checks whether the device's user agent suggests it's a tablet by comparing it
 * against known tablet patterns. Specifically, it identifies iPads and Android
 * tablets, ensuring they are not confused with mobile phones.
 */
export const isTabletUserAgent = (): boolean => {
	if (!globalThis.navigator?.userAgent.length) {
		return false;
	}
	return (
		IPAD_USER_AGENT.test(globalThis.navigator?.userAgent) ||
		(isAndroidUserAgent() && !MOBILE_STRING_IN_USER_AGENT.test(globalThis.navigator?.userAgent))
	);
};
const isDesktopSwitchEnabled = () => Cookies.get(DESKTOP_SWITCH_COOKIE_KEY) === 'true';
const isMobileUserAgent = (): boolean => isSupportedUserAgent() && !isDesktopSwitchEnabled();

// it is not possible to detect Safari on iOS directly
// so we need to exclude all other iOS rendering engines
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
export const isSafariIosRenderingEngine = (): boolean => {
	if (typeof navigator === 'undefined') {
		return false;
	}

	return (
		isIosUserAgent() &&
		!NON_SAFARI_IOS_RENDERING_ENGINE_USER_AGENT.test(globalThis.navigator?.userAgent)
	);
};

export const shouldShowReturnToMobileBanner = (): boolean => isSupportedUserAgent();

export const shouldShowReturnToMobileBannerMobileMvp = (): boolean => {
	return isSupportedUserAgent() && !isSafariIosRenderingEngine();
};

export const shouldShowDismissButton = () =>
	shouldShowReturnToMobileBanner() && isTabletUserAgent();
export const determineOperatingSystemAttribute = () => {
	if (isIosUserAgent()) {
		return 'ios';
	}
	if (isAndroidUserAgent()) {
		return 'android';
	}
	return 'other';
};
export default isMobileUserAgent;
